<template>
    <div>
        <div>
            <textarea class="p-3 border-next-gray-md-dark border-2 w-full" rows="9" v-model="textModel"></textarea>
        </div>
        <div class="grid grid-cols-7 gap-3">
            <div class="col-span-4">
                <VueMultiselect :searchable="true"
                                :multiple="true" :taggable="true"
                                :close-on-select="true"
                                :clear-on-select="true"
                                class="next-vue-multiselect"
                                placeholder="Tags"
                                deselectLabel="Deseleziona"
                                selectedLabel="Selezionato"
                                selectLabel="Seleziona"
                                :options="tagsAutocomplete.options"
                                @search-change="tagsAutocomplete.search"
                                @tag="tagsAutocomplete.add"
                                v-model="tagsAutocomplete.selection"
                                tagPlaceholder="Aggiungi tag">
                    <template v-slot:tag="{option, remove}">
                        <MultiselectOption @remove="remove(option)">
                            {{option}}
                        </MultiselectOption>
                    </template>
                </VueMultiselect>
            </div>
            <div class="col-span-3 grid grid-cols-5 gap-3 text-sm">
                <NextButton @click="$emit('chiudi')" variant="outline-secondary"
                            class="col-span-2 text-center py-2 px-4">Chiudi
                </NextButton>
                <NextButton variant="primary" class="col-span-3 text-center py-2 px-4" :disabled="$attrs.waiting" @click="save">Salva</NextButton>
            </div>
        </div>
    </div>

</template>

<script lang="ts">
import {Options, Vue, setup} from 'vue-class-component';
import NextButton from "@/components/NextButton.vue";
import MultiselectOption from "@/components/MultiselectOption.vue";
import Autocomplete from "@/setup/Autocomplete";
import tagsManager from "../api/Tags";


@Options({
    name:'FlagForm',
    components: {
        NextButton,
        MultiselectOption
    },
    props: {
        nota: String,
        tags: Array
    }
})
export default class FlagForm extends Vue {

    tagsAutocomplete = setup(() => Autocomplete(tagsManager, true))
    textModel!: string
    nota!: string
    tags!: string[]

    init(){
        this.textModel = this.nota
        //@ts-ignore
        this.tagsAutocomplete.add(this.tags)
    }

    created(){
        this.init()
    }

    save(){
        this.$emit('update:waiting', true)
        //@ts-ignore
        this.$emit('update:tags', this.tagsAutocomplete.selection)
        this.$emit('update:nota', this.textModel)
        this.$nextTick(()=>{
            this.$emit('save')
        })
    }

}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
